import type {
  ClientGeoArea,
  ClientGPSLocation
} from '@DigitaleDoerfer/digitale-doerfer-api';

import { EARTH_RADIUS } from '@/features/geo-area/constants/gps';

const degToRad = (value: number): number => (value * Math.PI) / 180;

/**
 * Calculates the distance between two GPS position in meters
 */
export const distance = (
  pos1?: ClientGPSLocation,
  pos2?: ClientGPSLocation
): number => {
  if (!pos1 || !pos2) return Number.MAX_SAFE_INTEGER;
  const dLat = degToRad(pos2.latitude - pos1.latitude);
  const dLon = degToRad(pos2.longitude - pos1.longitude);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degToRad(pos1.latitude)) *
      Math.cos(degToRad(pos2.latitude)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.abs(EARTH_RADIUS * c);
};

export const getMaxDistance = (
  center: ClientGPSLocation,
  around: ClientGeoArea[]
): number | undefined => {
  const distances = around
    .map((geoArea) => {
      const a = geoArea.center;
      const b = center;
      return a && b && distance(a, b);
    })
    .filter((distance) => distance != undefined);
  if (distances.length === 0) {
    return undefined;
  }
  return Math.max(...distances);
};
